import { Component,ViewChild } from '@angular/core';
import {
    ModalController, ViewController, NavParams, Slides, PopoverController, NavController,
    AlertController, ToastController
} from 'ionic-angular';
import { PopoverPage } from '../../about-popover/about-popover';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UserData} from "../../../providers/user-data";
import {JobSelectForm} from "../../utils/job-select/job-select";
import {MissionsListPage} from "../../missions/missions-list/missions-list";
import * as moment from 'moment';
import * as _ from "lodash";
import {HomePage} from "../../home/home";
import {UiData} from "../../../providers/ui-data";

@Component({
    selector: 'page-availability',
    templateUrl: 'availability.html'
})
export class AvailabilityPage {
    @ViewChild('slides') slides: Slides;

    skippable:any = true;
    savable:boolean = false;
    form : FormGroup;
    formData:any = true;

    status:any = "available";
    zipcode:any = "";

    available:boolean = true;
    available_at:any = false;
    min_date:any = false;
    max_date:any = false;

    jobs:any = [];
    departmentsList:any = [];
    searchFilters:any = {};

    sessionRef: any;
    userRef: any;
    submitAttempt:boolean=false;

    step:any=1;

    constructor(
        public popoverCtrl: PopoverController,
        public navCtrl: NavController,
        public navParams:NavParams,
        public formBuilder: FormBuilder,
        public userData: UserData,
        public alertCtrl:AlertController,
        public modalCtrl:ModalController,
        public uiData: UiData,
        public toastCtrl: ToastController
    ) {
        if(navParams.data.skippable != undefined)
            this.skippable = navParams.data.skippable;





    }
    ionViewDidLoad() {
        this.getUserInfos();

        if(this.navParams.data.step != undefined) {
            this.step = this.navParams.data.step;
            this.available = this.navParams.data.available;
            console.log(this.step,this.available);
            var that = this;
            setTimeout(function(){
                that.nextSlide(that.step);
                if(that.available)that.status = 'available';
                if(!that.available)that.status = 'not-available';
                that.slides.lockSwipeToPrev(true);
            },100);

        }
    }
    ionViewWillUnload() {

        this.sessionRef.unsubscribe();
        this.userRef.unsubscribe();
    }

    getUserInfos() {
        var that = this;
        if(!that.sessionRef || that.sessionRef.closed) {
            that.sessionRef = that.userData.userSession().subscribe(session => {
                if (session !== null) {
                    that.userRef = that.userData.load().subscribe(user => {
                        that.departmentsList = that.uiData.departmentsList();
                        let availability = that.userData.get('availability');
                        that.searchFilters = that.userData.get('searchFilters');
                        if(!that.searchFilters)that.searchFilters={};
                        if(!that.searchFilters.job)that.searchFilters.job={};
                        if(!that.searchFilters.job.jobs)that.searchFilters.job.jobs=[];

                        if (availability && availability.available) {
                            that.available =  availability.available;
                        }

                        if (availability && availability.available_at) {
                            //that.available_at =  availability.available_at;
                            var start = moment(availability.available_at,'DD/MM/YYYYY');
                            var now = moment();
                            if(start<now){
                                start = now;
                                start.add(15, 'days');
                            }
                            that.available_at = start.format('YYYY-MM-DD');
                            start = moment();
                            that.min_date = start.format('YYYY-MM-DD');
                            start.add(1, 'year');
                            that.max_date = start.format('YYYY-MM-DD');
                        }
                        else
                        {
                            var start = moment();
                            that.min_date = start.format('YYYY-MM-DD');
                            start.add(15, 'days');
                            that.available_at = start.format('YYYY-MM-DD');
                            start.add(1, 'year');
                            that.max_date = start.format('YYYY-MM-DD');

                        }
                        //that.status = "";
                        if (!that.available)
                        {
                            if (availability && availability.private) {
                                that.status = 'private';
                            }
                            else {
                                that.status = 'not-available';
                            }
                        }
                        else {
                            that.status = 'available';
                        }
                        this.zipcode = this.userData.get('address/cp');
                    });
                }
            });
        }

    }
    chooseJob()
    {
        let jobSelectModal = this.modalCtrl.create(JobSelectForm, { mode: "certificates" });
        jobSelectModal.onDidDismiss(data => {
            if(data.success)
            {
                this.formData.poste = data.name;
            }
            else
            {

            }
        });
        jobSelectModal.present();
    }
    onSlideChangeStart(event: Event) {
        let currentIndex = this.slides.getActiveIndex();

        this.slides.lockSwipeToPrev(true);

        if(currentIndex==1 && this.status == 'available')
        {

        }
        else if(currentIndex==3)
        {
            //var that=this;
            //setTimeout(function(){that.savable=true},150)
            this.savable=true;
            /*this.slides.pager=false;
            this.slides.centeredSlides=false;
            this.slides.update();
            this.slides.resize();*/
            //this.slides.lockSwipeToPrev(true);
            //this.slides.lockSwipeToNext(true);
        }
        else
        {
            this.savable=false;
        }
    }
    departmentChange(e)
    {
        if(e!="") {
            this.nextSlide(3);
        }

    }
    presentPopover(event: Event) {
        let popover = this.popoverCtrl.create(PopoverPage);
        popover.present({ ev: event });
    }
    nextSlide(i)
    {

        if(i==1 && this.status == 'available')i=2;
        if(i==1 && this.status == 'private')i=2;
        if(i==2 && this.zipcode && this.zipcode!="")i=3;
        if(i==3 && this.searchFilters && this.searchFilters.job.jobs && this.searchFilters.job.jobs.length>0 )i=4;
        if(i==4)
            this.saveAvailability();
            //this.skip(null);
        else
            this.slides.slideTo(i,500);
    }
    skip(event)
    {
        this.navCtrl.setRoot(MissionsListPage);
    }
    saveAvailability()
    {
        //this.slides.resize();
        this.submitAttempt=true;
        if(this.status=="available")
            this.userData.set('availability/available',true);
        this.userData.set('availability/private', false);
        if(this.status=="private") {
            this.userData.set('availability/available', false);
            this.userData.set('availability/private', true);
        }
        if(this.status=="not-available") {
            this.userData.set('availability/available', false);
            this.userData.set('availability/private', false);
            let french_date = '';
            let date_components = this.available_at.split('-');
            this.userData.set('availability/available_at', date_components[2]+"/"+date_components[1]+"/"+date_components[0]);
        }
        this.userData.set('address/cp', this.zipcode);
        if(!this.searchFilters.location)
        {
            this.searchFilters.location.address=this.zipcode;
            this.searchFilters.location.mode = "position";
            this.searchFilters.location.lat='';
            this.searchFilters.location.lng='';
        }
        this.userData.set('searchFilters', this.searchFilters);
        this.toastSuccess("Vos informations de disponibilité ont bien été enregistrées");
        this.navCtrl.setRoot(this.userData.loggedInDestination());
    }
    addJobFilter()
    {
        let jobSelectModal = this.modalCtrl.create(JobSelectForm, { mode: "certificates" });
        jobSelectModal.onDidDismiss(data => {
            if(data.success)
            {
                if(!this.searchFilters.job.jobs)this.searchFilters.job.jobs=[];
                let found = false;
                for(let y=0; y<this.searchFilters.job.jobs.length;y++){
                    if(this.searchFilters.job.jobs[y]==data.name)found=true;
                }
                if(!found) {
                    var redirect = false;
                    if(this.searchFilters.job.jobs.length==0)
                    {
                        var redirect = true;
                    }
                    this.searchFilters.job.jobs.push(data.name);
                    if(redirect)
                    {
                        this.saveAvailability();
                    }
                }
            }
            else
            {

            }
        });
        jobSelectModal.present();
    }
    removeJobFilter(job)
    {
        var jobs = [];
        if(this.searchFilters.job.jobs)
            for(let i = 0; i < this.searchFilters.job.jobs.length ; i++)
            {
                if(this.searchFilters.job.jobs[i] != job)
                {
                    jobs.push(this.searchFilters.job.jobs[i])
                }
            }
        this.searchFilters.job.jobs = jobs;
        if(this.searchFilters.job.jobs.length==0)
        {
            this.searchFilters.job.enabled = false;
        }
    }
    /***
     * Toast management
     * @param {string} message
     */

    toastSuccess(message: string)
    {
        let toast = this.toastCtrl.create({
            closeButtonText:"Ok",
            showCloseButton: true,
            cssClass: 'profile-bg',
            message: message,
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }
}



// WEBPACK FOOTER //
// ./src/pages/account/availability/availability.ts